var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "download"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 4,
    y: 18,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 3,
    y: 17,
    rx: 1,
    ry: 1,
    transform: "rotate(-90 5 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 17,
    y: 17,
    rx: 1,
    ry: 1,
    transform: "rotate(-90 19 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15a1 1 0 0 1-.58-.18l-4-2.82a1 1 0 0 1-.24-1.39 1 1 0 0 1 1.4-.24L12 12.76l3.4-2.56a1 1 0 0 1 1.2 1.6l-4 3a1 1 0 0 1-.6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1"
  })))));
};
export default SvgDownload;